import React from 'react'

export type PortalHeaderDetailLinkProps = {
	title?: string
	href?: string
}
const PortalHeaderDetailLink = ({
	title,
	href,
}: PortalHeaderDetailLinkProps) => {
	return (
		<a
			target="_blank"
			href={href}
			rel="noopener noreferrer"
			className="hover:underline"
		>
			{title}
		</a>
	)
}

export default PortalHeaderDetailLink
